import { i18n } from '../i18n';

const SUCCESS_KEYS = { create: 'created', update: 'updated', delete: 'deleted', add: 'added' };
const ERROR_KEYS = { create: 'createError', update: 'updateError', delete: 'deleteError', add: 'addError' };

export const getNotifyMessage = (type, action, entity) => {
  const keys = type === 'success' ? SUCCESS_KEYS : ERROR_KEYS;
  return i18n.t(`notify.${keys[action]}`, { entity: i18n.t(`notify.entities.${entity}`) });
};
